import CircularProgress from '@material-ui/core/CircularProgress';
import { DropdownInput } from '@trueprodigy/components';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { Fab } from '@material-ui/core';
import TextField from '@components/TextFieldCaseSetting';
import Button from '@material-ui/core/Button';
import { canEditSubject } from '@config/permissions/Can';
import DeleteIcon from '@material-ui/icons/Delete';
import AddIcon from '@material-ui/icons/Add';
import {
  fetchAllOwnerNumbers,
  addOwnerNumber,
  deleteOwnerNumber,
  updateOwnerNumber,
} from '@modules/appraisal/actions/owner';
import { fetchPropertyDropdowns } from '@modules/appraisal/actions/property';
import selector from './selector';
class PhoneNumbers extends Component {
  static propTypes = {
    property: ImmutablePropTypes.map,
    ownerId: PropTypes.any,
    isNew: PropTypes.any,
    fetchNumbers: PropTypes.func.isRequired,
    addNumber: PropTypes.func.isRequired,
    deleteNumber: PropTypes.func.isRequired,
    updateNumber: PropTypes.func.isRequired,
    fetchDropdowns: PropTypes.func.isRequired,
    dropdowns: PropTypes.any,
    viewOnly: PropTypes.any,
  };

  constructor(props) {
    super(props);
    this.state = {
      rowData: [],
      phoneNumber: '',
      phoneType: null,
      loaded: false,
    };
  }

  componentDidMount() {
    this.initializeData();
  }

  initializeData = async () => {
    this.props.fetchDropdowns({
      fieldName: 'phoneType',
      endpoint: '/appraisal/codes?type=Owner&name=Phone',
    });
    if (!this.props.isNew) {
      let data = await this.props.fetchNumbers({ ownerId: this.props.ownerId });

      if (data && data.results && data.results.length > 0) {
        this.setState({ rowData: data.results, loaded: true });
      } else {
        this.setState({ loaded: true });
      }
    }
  };

  addHandler = async () => {
    let data = await this.props.addNumber({
      ownerId: this.props.ownerId,
      payload: {
        phoneNumber: this.state.phoneNumber,
        phoneType: this.state.phoneType,
      },
    });
    if (data && data.results && data.results.length > 0) {
      let newRowData = JSON.parse(JSON.stringify(this.state.rowData));
      newRowData.push(data.results[0]);
      this.setState({
        rowData: newRowData,
        phoneType: null,
        phoneNumber: '',
      });
    }
  };

  deleteHandler = async phoneID => {
    await this.props.deleteNumber({
      phoneID,
    });
    let newRowData = JSON.parse(JSON.stringify(this.state.rowData));
    let result = [];
    for (let x = 0; x < newRowData.length; x++) {
      if (newRowData[x].phoneID !== phoneID) {
        result.push(newRowData[x]);
      }
    }
    this.setState({
      rowData: result,
      phoneType: null,
      phoneNumber: '',
    });
  };

  updateHandler = async i => {
    let data = await this.props.updateNumber({
      phoneID: this.state.rowData[i].phoneID,
      payload: {
        phoneType: this.state.rowData[i].phoneType,
        phoneNumber: this.state.rowData[i].phoneNumber,
        lastUpdate: this.state.rowData[i].updateDt,
      },
    });
    if (data && data.results && data.results.length > 0) {
      let newRowData = JSON.parse(JSON.stringify(this.state.rowData));
      for (let x = 0; x < newRowData.length; x++) {
        if (x === i) {
          newRowData[i] = data.results[0];
        }
      }
      this.setState({
        rowData: newRowData,
        phoneType: null,
        phoneNumber: '',
      });
    }
  };

  render() {
    const { property, dropdowns, isNew, viewOnly } = this.props;

    const isEditable = canEditSubject('AppraisalOwner');
    const certified =
      property.getIn(['data', 'rollCorrGroupStatus']) === 'Certified';

    return (
      <PhoneNumbers.PhoneNumberSection>
        <span>PHONE NUMBERS</span>
        {!this.state.loaded && !isNew ? (
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              padding: '30px',
            }}
          >
            <CircularProgress />
          </div>
        ) : (
          <div
            style={{ maxHeight: '700px', overflowY: 'auto', height: '100%' }}
          >
            {this.state.rowData.map((r, i) => {
              return (
                <div
                  key={r.phoneID}
                  style={{
                    padding: '0 20px',
                    display: 'flex',
                  }}
                >
                  <div
                    style={{
                      marginRight: 20,
                      marginTop: 10,
                      flex: '0 1 1000px',
                    }}
                  >
                    <DropdownInput
                      id={`drop-${i}`}
                      input={{
                        value: r.phoneType,
                        onChange: ({ value }) => {
                          // updateValue(key, value);
                          let newRowData = JSON.parse(
                            JSON.stringify(this.state.rowData),
                          );
                          newRowData[i].phoneType = value;
                          this.setState({ rowData: newRowData }, () => {
                            this.updateHandler(i);
                          });
                        },
                      }}
                      label={'Phone Type (Desc)'}
                      meta={{ touched: true }}
                      options={(
                        (dropdowns && dropdowns.get('data')
                          ? dropdowns.get('data').toJS().phoneType
                          : []) || []
                      ).map(item => ({
                        value: item.codeName,
                        label: `(${item.codeName}) - ${item.codeDescription}`,
                      }))}
                    />
                  </div>
                  <div
                    style={{
                      marginRight: 20,
                      marginTop: 10,
                      flex: '0 1 1000px',
                    }}
                  >
                    <TextField
                      id={`text-${i}`}
                      value={r.phoneNumber}
                      onChange={e => {
                        let newRowData = JSON.parse(
                          JSON.stringify(this.state.rowData),
                        );
                        let formattedPhoneNumber = e.target.value.replace(/\D/g, '');

                        if (formattedPhoneNumber.length > 10) {
                          formattedPhoneNumber = formattedPhoneNumber.slice(0, 10);
                        }

                        if (formattedPhoneNumber.length <= 3) {
                          // formattedPhoneNumber = formattedPhoneNumber;
                        } else if (formattedPhoneNumber.length <= 6) {
                          formattedPhoneNumber = formattedPhoneNumber.replace(/(\d{3})(\d{0,3})/, '$1-$2');
                        } else {
                          formattedPhoneNumber = formattedPhoneNumber.replace(/(\d{3})(\d{3})(\d{0,4})/, '$1-$2-$3');
                        }
                        newRowData[i].phoneNumber = formattedPhoneNumber;
                        newRowData[i].changed = true;
                        this.setState({ rowData: newRowData });
                      }}
                      style={{ width: '100%' }}
                      label={'Phone Number'}
                      onBlur={() => {
                        if (this.state.rowData[i].changed) {
                          this.updateHandler(i);
                        }
                      }}
                      // inputRef={idx === 1 && !disabled ? ref : null}
                      onKeyUp={e => {
                        if (
                          e.key === 'ArrowDown' &&
                          i < this.state.rowData.length - 1
                        ) {
                          let element = document.getElementById(
                            `text-${i + 1}`,
                          );
                          if (element) {
                            element.focus();
                            element.select();
                            e.preventDefault();
                            e.stopPropagation();
                          }
                        } else if (e.key === 'ArrowDown') {
                          let element = document.getElementById(`newNumber`);
                          if (element) {
                            element.focus();
                            element.select();
                            e.preventDefault();
                            e.stopPropagation();
                          }
                        }
                        if (e.key === 'ArrowUp' && i > 0) {
                          let element = document.getElementById(
                            `text-${i - 1}`,
                          );
                          if (element) {
                            element.focus();
                            element.select();
                            e.preventDefault();
                            e.stopPropagation();
                          }
                        }
                      }}
                    />
                  </div>
                  <div style={{ alignSelf: 'center', marginTop: 10 }}>
                    <Button
                      disabled={viewOnly}
                      onClick={() => {
                        this.deleteHandler(r.phoneID);
                      }}
                    >
                      <DeleteIcon color="primary" />
                    </Button>
                  </div>
                </div>
              );
            })}
            <div
              style={{
                padding: '0 20px',
                display: 'flex',
              }}
            >
              <div
                style={{
                  marginRight: 20,
                  marginTop: 10,
                  flex: '0 1 1000px',
                }}
              >
                <DropdownInput
                  id="newType"
                  input={{
                    value: this.state.phoneType,
                    onChange: ({ value }) => {
                      this.setState({ phoneType: value });
                    },
                  }}
                  label={'Phone Type (Desc)'}
                  meta={{ touched: true }}
                  options={(
                    (dropdowns && dropdowns.get('data')
                      ? dropdowns.get('data').toJS().phoneType
                      : []) || []
                  ).map(item => ({
                    value: item.codeName,
                    label: `(${item.codeName}) - ${item.codeDescription}`,
                  }))}
                />
              </div>
              <div
                style={{
                  marginRight: 20,
                  marginTop: 10,
                  flex: '0 1 1000px',
                }}
              >
                <TextField
                  id="newNumber'"
                  value={this.state.phoneNumber}
                  onChange={e => {
                    let formattedPhoneNumber = e.target.value.replace(/\D/g, '');

                    if (formattedPhoneNumber.length > 10) {
                      formattedPhoneNumber = formattedPhoneNumber.slice(0, 10);
                    }

                    if (formattedPhoneNumber.length <= 3) {
                      // formattedPhoneNumber = formattedPhoneNumber;
                    } else if (formattedPhoneNumber.length <= 6) {
                      formattedPhoneNumber = formattedPhoneNumber.replace(/(\d{3})(\d{0,3})/, '$1-$2');
                    } else {
                      formattedPhoneNumber = formattedPhoneNumber.replace(/(\d{3})(\d{3})(\d{0,4})/, '$1-$2-$3');
                    }

                    this.setState({ phoneNumber: formattedPhoneNumber });
                  }}
                  style={{ width: '100%' }}
                  label={'Phone Number'}
                  // inputRef={idx === 1 && !disabled ? ref : null}
                  onKeyUp={e => {
                    if (e.key === 'ArrowUp' && this.state.rowData.length > 0) {
                      let element = document.getElementById(
                        `text-${this.state.rowData.length - 1}`,
                      );
                      if (element) {
                        element.focus();
                        element.select();
                        e.preventDefault();
                        e.stopPropagation();
                      }
                    }
                  }}
                />
              </div>
              {
                this.props.ownerId ? (
                  <div style={{ alignSelf: 'center', marginTop: 10 }}>
                    <AddButton
                      size="small"
                      disabled={
                        !this.state.phoneNumber ||
                        !this.state.phoneType ||
                        !isEditable ||
                        certified ||
                        viewOnly
                      }
                      onClick={() => {
                        this.addHandler();
                      }}
                    />
                  </div>
                ) : null
              }
              
            </div>
          </div>
        )}
      </PhoneNumbers.PhoneNumberSection>
    );
  }
}

PhoneNumbers.SubBlockWrapper = styled.div`
  display: flex;
`;

PhoneNumbers.SubBlockContainer = styled.div`
  width: 50%;
  padding: 10px;
  border: 1px solid #ccc;

  &:first-child {
    margin-right: 20px;
  }

  > h5 {
    font-size: 16px;
    font-weight: 500;
  }
`;

PhoneNumbers.ButtonContainer = styled.div`
  padding: 20px 10px;
  text-align: right;
`;

PhoneNumbers.PhoneNumberSection = styled.div`
  padding: 10px;
  border: 1px solid black;
  position: relative;
  height: 100%;

  > span {
    position: absolute;
    top: -12px;
    left: 10px;
    display: block;
    background: white;
    padding: 0 10px;
  }
`;

const MuiFab = styled(Fab)`
  && {
    z-index: 9;
    margin-left: 10px;
    width: ${({ size }) => (size === 'small' ? '35px' : '56px')};
    height: ${({ size }) => (size === 'small' ? '20px' : '56px')};
    background-color: #36449d;
    cursor: ${({ preview }) => !preview && 'pointer'};
  }
`;

const AddButton = props => (
  <MuiFab aria-label="Add" color="primary" {...props}>
    <AddIcon />
  </MuiFab>
);

const mapDispatchToProps = dispatch => ({
  fetchNumbers: bindActionCreators(fetchAllOwnerNumbers, dispatch),
  addNumber: bindActionCreators(addOwnerNumber, dispatch),
  deleteNumber: bindActionCreators(deleteOwnerNumber, dispatch),
  updateNumber: bindActionCreators(updateOwnerNumber, dispatch),
  fetchDropdowns: bindActionCreators(fetchPropertyDropdowns, dispatch),
});

export default connect(
  selector,
  mapDispatchToProps,
)(PhoneNumbers);
